import { Axios } from './../shared/Axios';
import qs from 'qs';

class CouponService extends Axios {

    private static instance: CouponService;

    static get(): CouponService {
        if (!CouponService.instance) {
            CouponService.instance = new CouponService();
        }
        return CouponService.instance;
    }

    async getCoupons(data: object): Promise<any> {
        return this.instance.get(`/admin/coupon${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async updateCoupon(formData: FormData, id: number): Promise<any> {
        return this.instance.patch(`/admin/coupon/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

    }

    async saveCoupon(formData: FormData): Promise<any> {
        return this.instance.post(`/admin/coupon`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

    }

    async deleteCoupon(id: number): Promise<any> {
        return this.instance.delete(`/admin/coupon/${id}`)
    }

   

    async getUserCoupons(data: object): Promise<any> {
        return this.instance.get(`/admin/coupon/user${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async saveUserCoupon(data: object): Promise<any> {
        return this.instance.post(`/admin/coupon/user/code`, data)
    }

    async getCouponCodes(data: object): Promise<any> {
        return this.instance.get(`/admin/coupon/code${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async saveCouponCode(data: Object): Promise<any> {
        return this.instance.post(`/admin/coupon/code`, data)

    }

    async assignCouponCode(data: Object): Promise<any> {
        return this.instance.post(`/admin/coupon/code/assign`, data)

    }

    async deleteCouponCode(id: number): Promise<any> {
        return this.instance.delete(`/admin/coupon/code/${id}`)
    }

    async uploadCouponCode(formData: FormData): Promise<any> {
        return this.instance.post(`/admin/coupon/code/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

}


const couponService = CouponService.get();

export { couponService as CouponService }